import MentoringCardFooter from './MentoringCardFooter.vue';

export default MentoringCardFooter;



// WEBPACK FOOTER //
// ./src/pages/profile/modules/mentoring/components/cardfooter/index.ts